// 为了在每次请求时自动添加身份验证令牌，新增Axios拦截器配置文件，不修改现有代码。

import axios from 'axios';

import { checkAndStoreBrowserAndDeviceType, checkAndStoreIpInfo } from '@/utils/tools';

// console.log(navigator.userAgent);
// if (navigator.connection) {
//     console.log('Effective network type: ', navigator.connection.effectiveType);
//     console.log('Downlink: ', navigator.connection.downlink, 'Mbps');
//     console.log('RTT: ', navigator.connection.rtt, 'ms');
// } else {
//     console.log('Network Information API not supported.');
// }

// 获取用户的设备信息
checkAndStoreBrowserAndDeviceType();
// // 获取用户的ip信息
// checkAndStoreIpInfo();


axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    const addParam = (paramName) => {
        var value = localStorage.getItem(paramName);
        if (value) {
            if (config.method === 'get') {
                config.params = config.params || {};
                config.params[paramName] = value;
            } else {
                config.data = config.data || {};
                config.data[paramName] = value;
            }
        }
    };
    // console.log('999');

    // 添加必要的参数
    addParam('user');
    addParam('username');
    addParam('user_ip');
    addParam('user_ip_address');
    addParam('user_ip_province');
    addParam('user_ip_city');
    addParam('user_ip_country');
    addParam('deviceType');
    addParam('browserType');
    addParam('ny_auth');

    // 统一标记当前请求来源是 vue
    if (config.method === 'get') {
        config.params = config.params || {};
        config.params.client_type = 'vue';
    } else {
        config.data = config.data || {};
        config.data.client_type = 'vue';
    }

    return config;
}, error => {
    return Promise.reject(error);
});
